var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "YsDataTable",
        {
          attrs: {
            list: _vm.searchList,
            "button-list": _vm.buttonList,
            columns: _vm.columns,
            "fetch-method": _vm.fetchMethod,
            "list-field": "reportDetailList",
            "transform-params": _vm.handleFormatSearch,
            "page-size-alias": "page_size",
            "page-sizes": [100, 500, 1000],
            "page-size": 100,
            "use-data-field": ""
          },
          on: {
            "on-fetch-success": _vm.handleFetchSuccess,
            "on-reset": _vm.handleReset
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var row = ref.row
                return [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.hanleLookDetail(row)
                        }
                      }
                    },
                    [_vm._v("\n        查看详情\n      ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.refresh,
            callback: function($$v) {
              _vm.refresh = $$v
            },
            expression: "refresh"
          }
        },
        [
          _c(
            "template",
            { slot: "supply_id" },
            [
              _c("el-input", {
                attrs: { placeholder: "商家ID" },
                on: { input: _vm.handleChange },
                model: {
                  value: _vm.searchForm.supply_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchForm, "supply_id", $$v)
                  },
                  expression: "searchForm.supply_id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "supply_name" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "商家名称",
                    "remote-method": _vm.remoteMethod
                  },
                  on: { change: _vm.handleSelectChange },
                  model: {
                    value: _vm.searchForm.supply_name,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "supply_name", $$v)
                    },
                    expression: "searchForm.supply_name"
                  }
                },
                _vm._l(_vm.supplyNameOptions, function(item) {
                  return _c("el-option", {
                    key: item.supply_id,
                    attrs: { label: item.supply_name, value: item.supply_id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "city" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "城市",
                    multiple: ""
                  },
                  model: {
                    value: _vm.searchForm.city,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "city", $$v)
                    },
                    expression: "searchForm.city"
                  }
                },
                _vm._l(_vm.cityOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "market" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "市场",
                    multiple: ""
                  },
                  model: {
                    value: _vm.searchForm.market_id,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "market_id", $$v)
                    },
                    expression: "searchForm.market_id"
                  }
                },
                _vm._l(_vm.marketOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "purchase_group" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "代采组",
                    multiple: ""
                  },
                  model: {
                    value: _vm.searchForm.pgid,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "pgid", $$v)
                    },
                    expression: "searchForm.pgid"
                  }
                },
                _vm._l(_vm.purchaseGroupOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "dg_member" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "次品员",
                    multiple: ""
                  },
                  model: {
                    value: _vm.searchForm.dg_member_id,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "dg_member_id", $$v)
                    },
                    expression: "searchForm.dg_member_id"
                  }
                },
                _vm._l(_vm.defectiveProductSpecialistOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "reportMsg" }, [
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v("最多导出2w数据！")
            ])
          ]),
          _vm._v(" "),
          _c(
            "template",
            { slot: "table-content" },
            [
              _c(
                "el-card",
                { staticStyle: { "margin-bottom": "16px" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("汇总（全部）")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.totalDetail,
                        "tooltip-effect": "dark",
                        border: ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "total_return",
                          label: "总退换货"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "owe_pending",
                          label: "转欠货待处理"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "owe_processed",
                          label: "转欠货已换回"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "refund",
                          label: "退款"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "stagnant_debts",
                          label: "转呆账"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "bad_debt",
                          label: "转坏账"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "deduct",
                          label: "转抵扣"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报表详情",
            visible: _vm.isShowDetailDialog,
            width: "80%",
            top: "8vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowDetailDialog = $event
            }
          }
        },
        [
          _vm.isShowDetailDialog
            ? _c("reject-statement-detail", {
                attrs: { "detail-data": _vm.detailData }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ac88cf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ac88cf8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reject/RejectStatement.vue
// module id = null
// module chunks = 